import React from 'react';
//import  "./Intro.css"
import "./FormView.css"
import 'bootstrap/dist/css/bootstrap.min.css';
import CustomSelector from "../../Main_Components/CustomSelector/CustomSelector";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/free-regular-svg-icons";
import CustomMultiSelector from "../../Main_Components/CustomMultiSelector/CustomMultiSelector";
import CustomGroupSelector from "../../Main_Components/CustomGroupSelector/CustomGroupSelector";
import { Button } from "react-bootstrap";
import formoptions from "./formoptions.json"
import { useEffect } from "react";

function FormView(props) {
    const [category, setCategory] = React.useState("")
    const [indicators, setIndicators] = React.useState([])
    const [selectedyears, setSelectedYears] = React.useState([])
    const [missing, setmissing] = React.useState(0)
    const prevcategory = React.useRef();
    const prevformdata = React.useRef();
    const isFormchanged = (a, b) => {
        if (a !== undefined && b === undefined) {
            return true
        }
        if (a === undefined && b === undefined) {
            return false
        }
        else {
            if (a === undefined && Object.keys(b).length === 0) {
                return false
            }
            if (b === undefined && Object.keys(a).length === 0) {
                return false
            }
        }
        let akeys = (Object.keys(a))
        let bkeys = (Object.keys(b))
        if (akeys.length === 0 && bkeys.length === 0) {
            return false
        }
        if (akeys.length == bkeys.length) {
            for (let i = 0; i < akeys.length; i++) {
                if (akeys[i] !== bkeys[i]) {
                    return true
                }
                else {
                    switch (akeys[i]) {
                        case "category":
                            if (a["category"] !== b["category"]) {
                                return true
                            }
                            break
                        case "selectedyears":
                        case "indicators":
                            if (a[akeys[i]].length != b[akeys[i]].length) {
                                return true
                            }
                            else {
                                for (let j = 0; j < a[akeys[i]].length; j++) {
                                    if (a[akeys[i]][j].value != b[akeys[i]][j].value) {
                                        return true
                                    }
                                }
                            }
                            break;
                        case "areas":
                            if (a["areas"].length != b["areas"].length) {
                                return true
                            }
                            else {
                                for (let j = 0; j < a["areas"].length; j++) {
                                    if (a["areas"][j].value != b["areas"][j].value) {
                                        return true
                                    }
                                    else {
                                        if (a["areas"][j].group != b["areas"][j].group) {
                                            return true
                                        }
                                    }
                                }
                            }
                            break;
                    }
                }
            }

        }
        else {
            return true
        }
        return false
        // compare objects
    }

    let years = []
    for (let i = 2012; i < 2020; i++) {
        years.push({ value: i, label: i })
    }
    const findIndicators = () => {
        let options = []
        if (props.areas.length === 0) {
            return options
        }
        else {
            let group = props.areas[0]["group"]
            if (category === null) {
                return options
            }
            let categories = formoptions["formoptions"].filter(opt => {
                return (opt["geounit"] === group)
            })
            if (categories !== undefined) {
                let indicators = categories[0]["categories"].filter(element => {
                    return (element.name === category)
                })
                if (indicators.length === 0) {
                    return options
                }
                else {
                    for (let i = 0; i < indicators[0]["indicators"].length; i++) {
                        options.push({ value: indicators[0]["indicators"][i].name, label: indicators[0]["indicators"][i].name })
                    }
                    return options
                }
            }
        }
    }
    const findCategories = (group) => {
        let options = []
        if (group === undefined) {
            return options
        }
        let categories = formoptions["formoptions"].filter(opt => {
            return (opt["geounit"] === group)
        })
        for (let i = 0; i < categories[0]["categories"].length; i++) {
            options.push({ value: categories[0]["categories"][i].name, label: <div>{categories[0]["categories"][i].name}  <FontAwesomeIcon style={{ float: "right" }} title={"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod"} icon={faQuestionCircle} size={"lg"} /></div> })
        }
        return options
    }

    useEffect(() => {
        let s = localStorage.getItem("k")
        if (s != null) {
            let formdata = { "areas": props.areas, "category": category, "indicators": indicators, "selectedyears": selectedyears, "status": "updated" }
            props.setFormData(formdata)
        }
        if (props.areas.length === 0 && category === null && indicators.length === 0 && props.completed === true) {
            props.setCompleted(false)
        }
        prevcategory.current = category;
    })
    const submit = () => {
        if (props.areas.length === 0 || category === "" || indicators.length === 0 || selectedyears.length === 0) {
            return
        }
        let formdata = { "areas": props.areas, "category": category, "indicators": indicators, "selectedyears": selectedyears }
        let b = isFormchanged(formdata, prevformdata.current)
        if (b === true) {
            props.setFormData(formdata)
            props.setCompleted(true)
        }
        else {
            let s = localStorage.getItem("k")
            if (s != null) {
                let n = missing + 1
                setmissing(n)
            }
        }
        prevformdata.current = formdata;
    }
    return <div id={"border_form_view"} className={props.format}>
        <table>
            <tr>
                <td id={"select_header"} style={{ width: "25%", paddingLeft: "2%" }}>
                    0.1 Επιλέξτε γεωγραφικό επίπεδο
                </td>
                <td id={"select_header"} style={{ width: "25%" }}>
                    0.2 Επιλέξτε κατηγορία δείκτη
                </td>
                <td id={"select_header"} style={{ width: "25%" }}>
                    0.3 Επιλέξτε δείκτη
                </td>
                <td id={"select_header"} style={{ width: "25%" }}>
                    0.4 Επιλέξτε χρονολογία
                </td>
            </tr>
            <tr>
                <td style={{ width: "25%", paddingLeft: "2%" }}>
                    <CustomGroupSelector setchange={props.setCompleted} sendoptions={props.setAreas} />
                </td>
                <td style={{ width: "25%" }}>
                    <CustomSelector sendoptions={setCategory} pos={"auto"} width={"250px"} setchange={props.setCompleted} options={findCategories(props.areas.length !== 0 ? props.areas[0]["group"] : undefined)} />
                </td>
                <td style={{ width: "25%" }}>
                    <CustomMultiSelector setchange={props.setCompleted} clear={category === prevcategory.current} sendoptions={setIndicators} selectall={false} options={findIndicators()} />
                </td>
                <td style={{ width: "25%" }}>
                    <CustomMultiSelector setchange={props.setCompleted} sendoptions={setSelectedYears} selectall={false} options={years} />
                </td>
            </tr>
            <tr>
                <td style={{ paddingLeft: "2%", paddingTop: "3%", paddingBottom:"3%" }} colSpan={4}>
                    <button variant="primary" onClick={submit} className="filter-search-button"> <span id="search_btn_txt">Αναζήτηση</span></button>
                </td>
            </tr>
            <tr>

            </tr>

        </table>
    </div>;
}

export default FormView;